module.exports = __webpack_public_path__ + "static/media/alis11.efaa240c.jpg";